import {
  UseMutationOptions,
  DefaultOptions,
  QueryClient,
  QueryKey,
} from '@tanstack/react-query';

export const invalidateMultipleQueries = (
  queryClient: QueryClient,
  queryKeys: QueryKey[],
) =>
  Promise.all(
    queryKeys.map(key => queryClient.invalidateQueries({ queryKey: key })),
  );

export const removeMultipleQueries = (
  queryClient: QueryClient,
  queryKeys: QueryKey[],
) =>
  Promise.all(
    queryKeys.map(key => queryClient.removeQueries({ queryKey: key })),
  );

export const refetchMultipleQueries = (
  queryClient: QueryClient,
  queryKeys: QueryKey[],
) =>
  Promise.all(
    queryKeys.map(key => queryClient.refetchQueries({ queryKey: key })),
  );

export const queryConfig = {
  queries: {
    // throwOnError: true,
    refetchOnWindowFocus: false,
    retry: false,
    // 60000ms = 60sec = 1min
    staleTime: 1000 * 60,
  },
} satisfies DefaultOptions;

export type ApiFnReturnType<FnType extends (...args: any) => Promise<any>> =
  Awaited<ReturnType<FnType>>;

export type QueryConfig<T extends (...args: any[]) => any> = Omit<
  ReturnType<T>,
  'queryKey' | 'queryFn'
>;

export type MutationConfig<
  MutationFnType extends (...args: any) => Promise<any>,
> = UseMutationOptions<
  ApiFnReturnType<MutationFnType>,
  Error,
  Parameters<MutationFnType>[0]
>;
